<template>
    <div>
        <form class="col-12 p-0" @submit.prevent>
            <div class="form-row">
                <div class="form-group col-12">
                    <label for="short-description">{{
                        translate("Short description")
                    }}</label>
                    <textarea
                        class="form-control"
                        v-model="feedback.short_description"
                        id="short-description"
                    ></textarea>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-12">
                    <div class="mb-3">
                        <label
                            for="multiple-screenshots-field"
                            class="form-label"
                            >{{ translate("Screen shots") }}</label
                        >
                        <div class="custom-file-input-wrapper d-flex align-items-center">
                            <input
                                ref="screenshotsInput"
                                type="file"
                                id="multiple-screenshots-field"
                                multiple
                                @change="onFileSelected"
                                style="display: none"
                            />
                            <button
                                type="button"
                                class="btn btn-secondary btn-sm"
                                @click="$refs.screenshotsInput.click()"
                            >
                                {{ translate("Choose files") }}
                            </button>
                            <span class="ml-2 text-muted small">{{ fileSelectionLabel }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-12">
                    <label for="detailed-description">{{
                        translate("Detailed description")
                    }}</label>
                    <textarea
                        class="form-control"
                        v-model="feedback.detailed_description"
                        id="detailed-description"
                    ></textarea>
                </div>
            </div>

            <div class="col-12 d-flex justify-content-end">
                <button
                    v-if="submitting"
                    class="btn btn-success mr-4 spinner spinner-white spinner-right"
                    disabled
                >
                    {{ translate("Submitting issue") }}...
                </button>

                <button
                    v-else
                    class="btn btn-success mr-4"
                    :disabled="!isValid"
                    @click="submitIssue()"
                >
                    {{ translate("Submit") }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            submitting: false,
            feedback: {
                short_description: "",
                detailed_description: "",
            },
            images: [],
        };
    },

    computed: {
        fileSelectionLabel() {
            if (!this.images.length) {
                return this.translate("No files chosen");
            }
            return this.images.length === 1
                ? this.images[0].name
                : this.translate(":filesCount files selected", { filesCount: this.images.length });
        },

        isValid() {
            return (
                this.feedback.short_description.length > 0 &&
                this.feedback.detailed_description.length > 0
            );
        },
    },

    methods: {
        onFileSelected(event) {
            this.images = event.target.files;
        },

        makeFormData() {
            let formData = new FormData();
            formData.append(
                "short_description",
                this.feedback.short_description,
            );
            formData.append(
                "detailed_description",
                this.feedback.detailed_description,
            );

            for (let i = 0; i < this.images.length; i++) {
                formData.append(`images${i}`, this.images[i]);
            }

            return formData;
        },

        submitIssue() {
            var self = this;
            this.submitting = true;

            axios
                .post("/api/forms/issue", this.makeFormData())
                .then(function (response) {
                    self.showSwalSuccessPopup();
                    self.hideModals();
                    self.submitting = false;
                    self.$emit("formSubmitted");
                });
        },
    },
};
</script>
